/**
 * useTrackPageviews — fires a beacon to /api/track/pageview on every
 * client-side route change. Anonymous + non-blocking.
 *
 * Mount once near the root (inside <BrowserRouter>) so it always sees
 * useLocation() updates.
 */
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import axios from 'axios';

const API = process.env.REACT_APP_BACKEND_URL;

function getBrandSlug() {
  try {
    const u = new URL(window.location.href);
    const q = u.searchParams.get('brand');
    if (q) return q.toLowerCase();
    const host = window.location.hostname.toLowerCase();
    if (host.endsWith('.mykeyboss.com') && host !== 'www.mykeyboss.com') {
      return host.slice(0, -('.mykeyboss.com'.length));
    }
  } catch { /* noop */ }
  return null;
}

export default function useTrackPageviews() {
  const location = useLocation();

  useEffect(() => {
    // Fire-and-forget; ignore errors so a tracking failure can never break navigation
    axios.post(
      `${API}/api/track/pageview`,
      {
        path: location.pathname + location.search,
        referrer: document.referrer || null,
        brand_slug: getBrandSlug(),
        screen_w: window.innerWidth,
        screen_h: window.innerHeight,
      },
      { withCredentials: true },
    ).catch(() => {});
  }, [location.pathname, location.search]);
}
